import React, { CSSProperties } from 'react';
import { useContent } from '../content/ContentContext';

interface Props {
  className?: string;
  style?: CSSProperties;
}

/** Link social (Facebook/Instagram) alimentati dai contenuti editabili in dashboard. */
const SocialLinks: React.FC<Props> = ({ className = 'footer__socials', style }) => {
  const { t } = useContent();
  const facebook = t('social.facebook', 'https://www.facebook.com');
  const instagram = t('social.instagram', 'https://www.instagram.com');

  return (
    <div className={className} style={style}>
      <a href={facebook} target="_blank" rel="noreferrer noopener" aria-label="Facebook">
        <svg viewBox="0 0 24 24" fill="currentColor"><path d="M13 22v-8h3l1-4h-4V7.5c0-1 .5-2 2-2h2V2s-1.5-.5-3-.5C11.5 1.5 10 3.5 10 6v4H6v4h4v8z" /></svg>
      </a>
      <a href={instagram} target="_blank" rel="noreferrer noopener" aria-label="Instagram">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="18" height="18" rx="5" /><circle cx="12" cy="12" r="4" /><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" /></svg>
      </a>
    </div>
  );
};

export default SocialLinks;
